import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-solid-svg-icons';

// Only supports default which is color: dark and size: medium
//      and color: grey size: small
export const PencilIcon = (props) => {
    
    let style = '';

    // Handle sizes
    if (props.size === 'small') {
        style = style + ' pencil-icon-small';
    }
    if (props.size === 'medium') {
        style = style + ' pencil-icon-medium';
    }

    // Handle colors
    if (props.color === 'grey') {
        style = style + ' pencil-icon-grey';
    }

    // function handleOnClick ()  {
    //     props.onClick();
    // }

    return (
       <FontAwesomeIcon className={style.trim()}  icon={faPencil} />
    )
}
export default PencilIcon;

// <FontAwesomeIcon className={style.trim()} icon={faPencil} />



// WEBPACK FOOTER //
// ./src/components/icons/PencilIcon.js